import { render, staticRenderFns } from "./SalePricesInstructionsDetail.vue?vue&type=template&id=c3f49198&scoped=true"
import script from "./SalePricesInstructionsDetail.vue?vue&type=script&lang=js"
export * from "./SalePricesInstructionsDetail.vue?vue&type=script&lang=js"
import style0 from "./SalePricesInstructionsDetail.vue?vue&type=style&index=0&id=c3f49198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f49198",
  null
  
)

export default component.exports